import { Check, AlertTriangle } from "lucide-react";
import { imageUrl } from "@/lib/api";

const Side = ({ label, src, testid }) => (
  <figure className="space-y-1.5" data-testid={testid}>
    <figcaption className="font-ui text-[11px] uppercase tracking-wider text-slate-400">{label}</figcaption>
    <img src={src} alt={label} className="w-full rounded-md shadow-lg shadow-black/40" />
    <div className="flex items-end gap-2">
      <img src={src} alt="" className="w-[50px] rounded-sm" data-testid={`${testid}-thumb`} />
      <span className="font-ui text-[10px] text-slate-500 leading-tight">Amazon search-result size</span>
    </div>
  </figure>
);

export const CoverCompare = ({ book, candidate, actionLabel, onConfirm, onCancel }) => (
  <div ref={(el) => el?.scrollIntoView({ behavior: "smooth", block: "nearest" })}
    className="rounded-lg border border-gold-400/30 bg-navy-950/60 p-3 space-y-3" data-testid="cover-compare">
    <div className="grid grid-cols-2 gap-3">
      <Side label="Current cover" src={`${imageUrl(book.cover_image_id)}?t=${book.cover_image_id}`} testid="cover-compare-current" />
      <Side label={candidate.label} src={candidate.src} testid="cover-compare-candidate" />
    </div>
    {candidate.warning && (
      <p data-testid="cover-compare-mismatch" className="flex items-start gap-2 rounded-md bg-amber-500/10 border border-amber-400/30 px-3 py-2 font-ui text-xs text-amber-200">
        <AlertTriangle className="w-4 h-4 shrink-0 mt-px" />
        <span><b>Doesn't match this book:</b> {candidate.warning}. You can still use it.</span>
      </p>
    )}
    {candidate.printIssue && (
      <p data-testid="cover-compare-print-issue" className="flex items-start gap-2 rounded-md bg-rose-500/10 border border-rose-400/30 px-3 py-2 font-ui text-xs text-rose-200">
        <AlertTriangle className="w-4 h-4 shrink-0 mt-px" />
        <span><b>Not print-ready:</b> {candidate.printIssue}. Fine for ebooks; the paperback export will ask for another design.</span>
      </p>
    )}
    <div className="flex justify-end gap-2">
      <button data-testid="cover-compare-cancel" onClick={onCancel}
        className="font-ui text-sm text-slate-300 hover:text-slate-100 rounded-lg px-3 py-2 transition-colors">Keep current</button>
      <button data-testid="cover-compare-confirm" onClick={onConfirm}
        className="flex items-center gap-2 font-ui text-sm font-medium bg-gold-400 hover:bg-gold-300 text-stone-950 rounded-lg px-4 py-2 transition-colors">
        <Check className="w-4 h-4" /> {actionLabel}
      </button>
    </div>
  </div>
);
